import React, {useEffect} from 'react';
import './ConfirmationComponent.css'; 
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Box,
} from "@mui/material";
import {
  Check as CheckIcon,
} from "@mui/icons-material";


const ConfirmationComponent = ({message}) => {
  // const navigate = useNavigate();
  // useEffect(() => {

  //   const handleMainPage = () => {
  //     navigate("/home");
  //   };

  //   const timer = setTimeout(handleMainPage, 1000);

  //   return () => clearTimeout(timer);
  // }, [navigate]);

  return (
    <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginTop: { xs: "100px", sm: "300px" },
    }}
  >
    <div
      style={{
        margin: "16px",
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        backgroundColor: "green",
        border: "4px solid gray",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CheckIcon style={{ color: "white", fontSize: "28px" }} />
    </div>
    <Typography variant="body1">Form saved</Typography>
    <Typography variant="body2">Thanks for sharing your info!</Typography>
    <Typography variant="body2">You may close this window now</Typography>
  </Box>
);
};

export default ConfirmationComponent;